import { Address } from '../../../../../../../types/Common';
import { Coord } from '../../../../../../../types/MapBox';
import useAddressCoords from '../../../../../../common/src/hooks/useAddressCoords';
import { flowIdRiskAnalysisNL } from '../../../../constants/flowIds';
import useCurrentGroup from '../../../../hooks/useCurrentGroup';
import { FlowsQuestionAnswer } from '../../../../types/FlowsTypes';
import { HomeSearchAnswer } from '../../../input/advisory-flow-inputs/home/HomeInputComponent';

interface Props {
  answers: FlowsQuestionAnswer[];
  flowId?: string;
}

interface Response {
  address?: Address;
  coords?: Coord[][];
  isLoading: boolean;
}

const riksAnalysisIds = [
  flowIdRiskAnalysisNL,
  // flowIdRiskAnalysisShortBE,
  // flowIdRiskAnalysisBE,
];

const useAddressForLeafletMap = ({ answers, flowId }: Props): Response => {
  const currentGroup = useCurrentGroup();

  const getCorrectAddressAnswer = (): HomeSearchAnswer | undefined => {
    if (riksAnalysisIds.includes(flowId || '')) {
      return answers.find(
        ({ id, index }) =>
          id === 'residence.address' &&
          // eslint-disable-next-line eqeqeq
          (currentGroup?.index == null || index == currentGroup?.index),
      )?.answer as HomeSearchAnswer;
    }
    return answers.find(
      ({ id, index }) =>
        (id === 'home.home_search' || id === 'home.address') &&
        // eslint-disable-next-line eqeqeq
        index == currentGroup?.index,
    )?.answer as HomeSearchAnswer;
  };

  const getAddressObject = (answer?: HomeSearchAnswer) => {
    if (riksAnalysisIds.includes(flowId || '')) {
      return answer as Address;
    }
    return answer?.address;
  };

  const AddressAnswer = getCorrectAddressAnswer();
  const addressObject = getAddressObject(AddressAnswer);
  const { coords, isLoading } = useAddressCoords(addressObject);
  const coordinates = AddressAnswer?._local?.coordinates || coords;

  return {
    address: { ...addressObject, ...coordinates?.[0]?.[0] },
    coords: coordinates,
    isLoading,
  };
};

export default useAddressForLeafletMap;
